<template>
  <div id="login">
    <div class="loginContainer">
      <div class="logoArea">
        <img src="@/assets/img/SURREALM/SurRealm_logo.png" class="logoSURREALM" />
      </div>
      <label class="lblSiginTitle">{{ $t('SURREALM.ForgetPw.PageName') }}</label>
      <label class="lblSiginSubTitle">{{ $t('SURREALM.ForgetPw.SubTitle') }}</label>

      <input class="txtbForgetPwEmail" v-model.trim="email" :placeholder="placeholder.email" />

      <button class="btnSURREALMLogin" @click="SendMail">{{ $t('SURREALM.ForgetPw.SendMail') }}</button>
      <label class="lblNoAcc">{{ $t('SURREALM.ForgetPw.RememberPw') }}</label>
      <button class="btnContactUs" @click="ToLoginPage">{{ $t('SURREALM.ForgetPw.Login') }}</button>
    </div>
    <div class="loginBackgroundM"></div>
  </div>
</template>

<script>
//import sha256 from 'sha256';

export default {
  data() {
    return {
      email: '',
      placeholder: {
        email: this.$t('SURREALM.ForgetPw.PlaceholderEmail'),
      },
    };
  },
  methods: {
    SendMail() {
      if (!this.TestEmail(this.email)) {
        this.$toasted.show(this.$t('SURREALM.Register.ErrMsg.Account'), {
          icon: 'warning',
          position: 'bottom-center',
          duration: 3500,
        });
      } else {
        //TODO Call API send ForgetPW Mail (params: email) url QueryString (email,serial ex: ?e=ian@faya.com.tw&s=1)
        console.log('SendMail');
        let data = {
          account: this.email
        }        
        this.$store.dispatch('ForgetPW', data).then((res) => {
          this.$router.push({ path: '/SURREALM/ForgetPWDone' });
          res;
        });
      }
    },
    ToLoginPage() {
      this.$router.push({ path: '/SURREALM/Login' });
    },
  },
};
</script>
